<template>
  <Modal>
    <Modal.Title>
      <span class="flex items-center gap-2.5">
        <span
          class="flex size-[30px] items-center justify-center rounded-full bg-red-200/50"
        >
          <AlertIcon class="size-4 text-red-700 -mt-px" />
        </span>
        {{ title }}
      </span>
    </Modal.Title>
    <Modal.Body>
      <div class="mb-3">
        Are you sure you want to archive
        <span class="font-medium">{{ filesCopy }}</span> from Dacr?
      </div>
      <div>
        By archiving, you will lose your Dacr copyright protection history. You
        will not be able to recover
        {{ pluralize('this copyright', files.length) }} once it is archived.
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :size="isMobile ? 'lg' : 'md'" @click="close()">
        Cancel
      </Button>
      <Button
        variant="danger"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleClick"
      >
        Archive
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import { openModal, Modals } from '@/shared/dialogs/modals'
import type { File } from '@/shared/graphql/router/graphql'
import { useDevice } from '@/shared/composables/useDevice'
import pluralize from 'pluralize'

const { close } = useModal()
const { isMobile } = useDevice()

const props = defineProps<{
  files: File[]
}>()

const title = computed(() => {
  if (props.files.length === 1) return 'Archive copyright?'
  return 'Archive copyrights?'
})

const filesCopy = computed(() => {
  if (props.files.length === 1) return props.files[0].name
  return `${props.files.length} copyrights`
})

const handleClick = () => {
  openModal(Modals.ConfirmArchiveFiles, {
    props: { files: props.files },
  })
}
</script>
